import { Navigate } from 'react-router';
import { PRAYERS } from '@/domain/prayer';
import { markFor } from '@/domain/streaks';
import { useAppState } from '@/state/useAppState';
import { useDayRecord } from '@/state/useDayRecord';

/**
 * `/log` is a real place, so the tab that goes there can be a link like the
 * others rather than a button that navigates. It resolves to the first prayer
 * of the day not yet recorded, or Fajr once they all are.
 */
export function NextPrayer() {
  const { today } = useAppState();
  const { day, loading } = useDayRecord(today);
  if (loading) return null;
  const next = PRAYERS.find((p) => !markFor(day, p).prayed) ?? PRAYERS[0];
  return <Navigate to={`/log/${next}`} replace />;
}
